var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialMediaFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.271 8.167a8 8 0 1 0-9.932 7.764v-5.32h-1.65V8.168h1.65V7.114c0-2.723 1.232-3.985 3.906-3.985.507 0 1.381.1 1.739.198v2.216c-.189-.02-.517-.03-.924-.03-1.312 0-1.819.498-1.819 1.79v.864h2.613l-.449 2.445H9.241v5.496a8 8 0 0 0 7.03-7.941"
})));
export default SvgSocialMediaFacebook;